import { EventType, MessageEvent } from './types';

export class EventManager {
  private listeners: Map<EventType, Set<Function>> = new Map();
  private baseUrl: string;
  private iframe: HTMLIFrameElement | null = null;
  private boundHandleMessage: (event: globalThis.MessageEvent) => void;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.boundHandleMessage = this.handleMessage.bind(this);
    this.setupMessageListener();
  }

  private setupMessageListener(): void {
    window.addEventListener('message', this.boundHandleMessage);
  }

  private handleMessage(event: globalThis.MessageEvent): void {
    // 验证消息来源
    if (event.origin !== this.baseUrl) {
      return;
    }

    const { type, data } = event.data as MessageEvent;

    // 触发对应的事件监听器
    switch (type) {
      case 'chat-ready':
        this.emit('ready', data);
        break;
      case 'chat-message':
        this.emit('message', data);
        break;
      case 'chat-error':
        this.emit('error', data);
        break;
      case 'unread-count':
        this.emit('unread-update', data);
        break;
    }
  }

  public setIframe(iframe: HTMLIFrameElement | null): void {
    this.iframe = iframe;
  }

  public sendToIframe(type: string, data: any): void {
    if (!this.iframe || !this.iframe.contentWindow) {
      console.warn('FloatingChat: iframe not ready');
      return;
    }

    this.iframe.contentWindow.postMessage(
      { type, data },
      this.baseUrl
    );
  }

  public on(event: EventType, callback: Function): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  public off(event: EventType, callback: Function): void {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.delete(callback);
    }
  }

  public emit(event: EventType, data?: any): void {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`FloatingChat: Error in ${event} callback:`, error);
        }
      });
    }
  }

  public destroy(): void {
    window.removeEventListener('message', this.boundHandleMessage);
    this.listeners.clear();
    this.iframe = null;
  }
}
